module.exports = __webpack_public_path__ + "static/media/ssec.8901092d.png";